import Box from '@mui/material/Box';
import { useCallback, useState } from 'react';

import { Job, JobInvoicing } from '~hooks/useJob/models';
import JobCardPdfTypeDialog from '~hooks/useJobCardPdf/JobCardPdfTypeDialog';
import { JobCardPdfRecipientType } from '~hooks/useJobCardPdf/models';
import { useJobCardPdf } from '~hooks/useJobCardPdf/useJobCardPdf';

import { columns, gridTemplateColumns } from './jobs-table-columns';
import TableHeader from './TableHeader';
import TableRow from './TableRow';

interface JobsTableProps {
  jobs: JobInvoicing[];
}

export default function JobsTable({ jobs }: JobsTableProps) {
  const { generateJobCardPdf, generatingJobIds } = useJobCardPdf();
  const [pdfDialogJob, setPdfDialogJob] = useState<Job | null>(null);

  const handleViewJobCardPdf = useCallback((job: Job) => {
    setPdfDialogJob(job);
    return Promise.resolve();
  }, []);

  const handlePdfTypeSelect = useCallback(
    (recipientType: JobCardPdfRecipientType) => {
      if (pdfDialogJob) {
        generateJobCardPdf(pdfDialogJob, recipientType);
      }
      setPdfDialogJob(null);
    },
    [generateJobCardPdf, pdfDialogJob],
  );

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridAutoRows: 'auto',
          gridTemplateColumns,
          gridTemplateRows: '35px',
        }}
      >
        {columns.map((column) => (
          <TableHeader key={column.key} title={column.title} sx={column.sx} />
        ))}

        {jobs.map((job) => (
          <TableRow
            key={job.id}
            job={job}
            onViewJobCardPdf={handleViewJobCardPdf}
            isGeneratingJobCardPdf={generatingJobIds.has(job.id)}
          />
        ))}
      </Box>

      <JobCardPdfTypeDialog
        isOpen={pdfDialogJob !== null}
        onClose={() => setPdfDialogJob(null)}
        onSelect={handlePdfTypeSelect}
      />
    </>
  );
}
